import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';

// 定义全局变量
(window as any).BASE_URL = 'https://ai-tongue-ui.dev.zhi-yuan.net/api';

// 定义自定义主题
const theme = {
  token: {
    // 设置主色调为 #58BEBF
    colorPrimary: '#58BEBF',
    // 设置链接颜色
    colorLink: '#58BEBF',
    // 设置成功状态颜色
    colorSuccess: '#58BEBF',
    // 设置信息状态颜色
    colorInfo: '#58BEBF',
  },
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ConfigProvider locale={zhCN} theme={theme}>
    <App />
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
